export default __webpack_public_path__ + "static/raven-3-a-c2bbd9b59d52f877da20f20ba651f188.webp";